import { FC } from 'react';
import SuperTransfer, { SuperTransferProps } from '../SuperTransfer';
import SearchFormItem from './subpage/searchFormItem';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { FormInstance } from 'antd/lib/form';

export interface SearchFormSuperTransferProps extends BaseSearchFormItemProps {
  /** SuperTransfer Props */
  superTransferProps?: SuperTransferProps;
}
/** 穿梭表单 */
export const SearchFormSuperTransfer: FC<SearchFormSuperTransferProps> = props => {
  const {
    superTransferProps,
    isDetail,
    form,
    ...resProps
  } = props;
  if (!superTransferProps) return null;
  const handleBeforeFetch = (params: any) => {
    if (!superTransferProps.beforeFetch) return params;
    return superTransferProps.beforeFetch?.(params, form?.getFieldsValue(true));
  };
  const handleChange = (value: any, _?: FormInstance, index?: number) => {
    superTransferProps.onChange?.(value, form, index);
  };

  return (
    <>
      <SearchFormItem
        {...resProps}
        validateTrigger="onChange"
      >
        <SuperTransfer
          {...superTransferProps}
          disabled={isDetail || superTransferProps.disabled}
          beforeFetch={handleBeforeFetch}
          onChange={handleChange}
        />
      </SearchFormItem>
    </>
  );
};

SearchFormSuperTransfer.displayName = SearchFormItemEnum.SearchFormSuperTransfer;

export default SearchFormSuperTransfer;
